import { useEffect } from 'react'

const registerInterestUrl = 'https://register.gaiapowered.co.uk'

const benefits = [
  'Customers throughout the UK',
  'Pre-qualified leads and projects',
  'Fast, reliable payment terms',
  'Support from our technical and compliance team',
  'Access to Gaia Powered branding and marketing materials',
]

const WorkWithUs = () => {
  useEffect(() => {
    document.title = 'Work with Gaia Powered'
  }, [])

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary-green to-secondary-green py-20 md:py-32">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-poppins font-bold mb-6">
              Work with Gaia Powered
            </h1>
            <p className="text-xl md:text-2xl">
              Join our network of trusted subcontractors
            </p>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-16 md:py-24">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-lg text-gray-700">
              We're always looking for skilled, reliable subcontractors to join our network and help
              us deliver exceptional renewable energy installations to homeowners and businesses across
              the UK. If you'd like to register your interest in working with Gaia Powered and servicing
              our customers, we'd love to hear from you.
            </p>
            <br />
          <a
            href={registerInterestUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-primary-green text-white px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Register Interest
          </a>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 md:py-24 bg-gray-50">
        <div className="container-custom">
          <h2 className="text-3xl md:text-4xl font-poppins font-bold text-dark-plum mb-12 text-center">
            Why Work with Us
          </h2>
          <ul className="max-w-2xl mx-auto space-y-4">
            {benefits.map((benefit) => (
              <li key={benefit} className="flex items-start gap-3">
                <svg
                  className="w-6 h-6 text-primary-green flex-shrink-0 mt-0.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                </svg>
                <span className="text-lg text-gray-700">{benefit}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-gradient-to-br from-primary-green to-secondary-green">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-poppins font-bold mb-6">
            Ready to Join Us?
          </h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Register your interest today and become part of the Gaia Powered installer network.
          </p>
          <a
            href={registerInterestUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-primary-green px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Register Interest
          </a>
        </div>
      </section>
    </div>
  )
}

export default WorkWithUs
